'use strict';
import * as _ from 'lodash';
import { times } from 'lodash';
import * as commonConstants from "../constants/constantStrings";
import * as worklistConstants from '../constants/worklist-constants';
import { CannedNotesModel } from '../models/cannedNotesModel';

export class ModalService {

  static $inject = [
    '$ionicPopup',
    '$ionicModal',
    '$ionicPopover',
    'ionicDatePicker',
    '$rootScope',
    'appVersionNumber',
    '$q',
    'WorklistFilterViewModel',
    'PrinterDocumentViewModel',
    'authService',
    'fullAppVersion'
  ];

  constructor($ionicPopup, $ionicModal, $ionicPopover, ionicDatePicker,
              $rootScope, appVersionNumber, $q,
              WorklistFilterViewModel,
              PrinterDocumentViewModel,
              authService, fullAppVersion) {
    this.popupsDictionary = {};
    this.$rootScope = $rootScope;
    this.WorklistFilterViewModel = WorklistFilterViewModel;
    this.PrinterDocumentViewModel = PrinterDocumentViewModel;
    this.appVersionNumber = appVersionNumber;
    this._qService = $q;
    this.$ionicPopover = $ionicPopover;
    this.$ionicModal = $ionicModal;
    this.$ionicPopup = $ionicPopup;
    this.ionicDatePicker = ionicDatePicker;
    this.authService = authService;
    this.fullAppVersion = fullAppVersion;
  }

  showConfirmation(action, text, params) {
    params = params || {};

    let confirmPopup = this.$ionicPopup.confirm({
      title: params.title || 'Techpad',
      template: text,
      okText: params.okText || 'Yes',
      cancelText: params.cancelText || 'No'
    });

    confirmPopup.then((res) => {
      res && action && typeof action === "function" && action();

      return res;
    });

    return confirmPopup;
  }

  showConfirmationAsync(text, params) {
    return new Promise((resolve, reject) => {
      params = params || {};

      this.$ionicPopup.confirm({
        title: params.title || commonConstants.DEFAULT_POPUP_HEADER,
        template: text,
        okText: params.okText || commonConstants.DEFAULT_POPUP_CONFIRM_BUTTON_TEST,
        cancelText: params.cancelText || commonConstants.DEFAULT_POPUP_DECLINE_BUTTON_TEST,
        okType: params.okType || commonConstants.DEFAULT_POPUP_CONFIRM_BUTTON_CLASS,
        cancelType: params.cancelType || commonConstants.DEFAULT_POPUP_DECLINE_BUTTON_CLASS
      })
      .then((res) => {
        resolve(res);
      });
    });
  }

  parseError(error) {
    return (error && error.data && (error.data.Message || error.data.message)) || (error && (error.Message || error.message)) || (error && typeof error === "string");
  }

  showErrorAlert(error) {
    this.$ionicPopup.alert({
      title: 'Techpad',
      template: error,
      okText: 'OK',
    });
  }

  showAlert(text, action, messageIdentifier, title, buttonText) {
    if (messageIdentifier && this.popupsDictionary[ messageIdentifier ]) {
      this.popupsDictionary[ messageIdentifier ].close();
    }

    let alertPopup = this.$ionicPopup.alert({
      title: title || 'Techpad',
      template: text,
      cssClass: messageIdentifier,
      okText: buttonText || 'OK',
    });
    alertPopup.then((buttonClickPerformed) => {
      if (buttonClickPerformed && action) {
        action();
      }
    });

    if (messageIdentifier) {
      this.popupsDictionary[ messageIdentifier ] = alertPopup;
    }

    return alertPopup;
  }

  async showAlertAsync(text) {
    return new Promise((resolve) => {
      let alertPopup = this.$ionicPopup.alert({
        title: 'Techpad',
        template: text,
        okText: 'OK',
      });
      alertPopup.then(() => {
        resolve();
      });
    });
  }

  showErrorMessage(error, status, restrictBackdropClickToClose) {

    let scope = this.$rootScope.$new();
    scope.error = error;

    let defer = this._qService.defer();

    scope.$on('modal.removed', () => {
      defer.resolve();
    });

    let ignoreMessages = [
      "The provider could not determine the Decimal value. For example, the row was just created, the default for the Decimal column was not available, and the consumer had not yet set a new Decimal value."
    ];

    if (typeof error === "string") {
      scope.error = {
        errorId: status,
        message: error
      };

    } else if (error && (error.ExceptionMessage || error.Message)) {

      let message = error.ExceptionMessage || error.Message || error;

      if (ignoreMessages.indexOf(message) > -1) {
        message = "An error has occurred. Please contact MagView support at 800-553-8996 and report this error number: #" + status;
      }

      scope.error = {
        errorId: status,
        message: message,
        details: error.StackTrace
      };
    } else if (error && error.data) {
      scope.error = error.data;
    }
    if(!error){
      debugger;
    }
    if (status === 404 || !error || error.status === 0) {
      scope.error = {errorId: 404, message: "Server is not reachable at the moment", details: error};
    }
    scope.type = 'Server Error';
    scope.version = this.fullAppVersion;
    scope.stamp = new Date();
    this.$ionicModal.fromTemplateUrl('views/templates/errorMessage.html', ($ionicModal) => {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up',
      backdropClickToClose: !restrictBackdropClickToClose
    });

    return defer.promise;
  }

  async showAdvancedConfirmationAsync(params){
    return new Promise((resolve) => {
      let confirmPopup = this.$ionicPopup.show({
        template: params.text,
        title: params.title,
        buttons: [
          {
            text: params.cancelButtonText || commonConstants.advancedConfirmationCancelButtonText,
            type: params.cancelButtonClass || commonConstants.modalButtonDefaultClass,
            onTap(e) {
              return commonConstants.advancedConfirmationCancelResponse;
            }
          },
          {
            text: params.saveButtonText || commonConstants.advancedConfirmationSaveButtonText,
            type: params.saveButtonClass || commonConstants.modalButtonDefaultClass,
            onTap(e) {
              return commonConstants.advancedConfirmationSaveResponse;
            }
          },
          {
            text: params.exitButtonText || commonConstants.advancedConfirmationDiscardButtonText,
            type: params.exitButtonClass || commonConstants.modalButtonDefaultClass,
            onTap(e) {
              return commonConstants.advancedConfirmationDiscardResponse;
            }
          }
        ]
      });
      confirmPopup.then((response) => {
        resolve(response);
      });
    });
  }

  async showMyriadReferral(params) {
    return new Promise((resolve) => {
      if (!params.options || params.options.length === 0) {
        params.options = [
          { Value: commonConstants.MYRIAD_MODAL_AGREED_OPTION, Caption: commonConstants.MYRIAD_MODAL_AGREED },
          { Value: commonConstants.MYRIAD_MODAL_INTERESTED_OPTION, Caption: commonConstants.MYRIAD_MODAL_INTERESTED },
          { Value: commonConstants.MYRIAD_MODAL_NOT_INTERESTED_OPTION, Caption: commonConstants.MYRIAD_MODAL_NOT_INTERESTED }
        ];
      }
      
      let scope = this.$rootScope.$new();
      scope.options = params.options;
      
      if (params.previousSelection) {
        scope.selectedOption = params.previousSelection;
        scope.options.forEach(opt => {
          opt.IsSelected = opt.Value === params.previousSelection;
        });
      } else {
        scope.selectedOption = null;
        scope.options.forEach(opt => opt.IsSelected = false);
      }

      scope.description = params.description || '';
      scope.title = params.title;
      scope.params = {
        ...params,
        showSkipButton: this.$rootScope.techpadSettings.IsDisplaySkipButtonOnMyriadReferralModal
      };

      scope.skip = () => {
        scope.modal.hide();
        resolve({ 
            response: commonConstants.MYRIAD_MODAL_SKIP, 
            selectedOption: scope.selectedOption, 
            shouldCloseWorklist: false 
          });
      };

      scope.selectOption = (option, event) => {
        scope.showError = false;
        if (option.IsSelected && scope.selectedOption === option.Value) {
          scope.selectedOption = null;
          option.IsSelected = false;
          return;
        }
        
        scope.options.forEach(opt => opt.IsSelected = false);
        option.IsSelected = true;
        scope.selectedOption = option.Value;
      };

      scope.confirm = () => {
        if (!scope.selectedOption) {
          scope.showError = true;
          return;
        }
        scope.showError = false;
        scope.modal.hide();
        resolve(
          { 
            response: commonConstants.MYRIAD_MODAL_CONFIRM, 
            selectedOption: scope.selectedOption 
          });
      };

      scope.viewRiskAssessment = () => {
        scope.selectOption({Value : 'review'});
        scope.confirm();
      };

      scope.cancel = () => {
        scope.modal.hide();
        resolve(
          { 
            response: commonConstants.MYRIAD_MODAL_CLOSE,
            selectedOption: scope.selectedOption, 
            shouldCloseWorklist: false 
          });
      };

      this.$ionicModal.fromTemplateUrl('views/templates/myriadReferral.html', ($ionicModal) => {
        scope.modal = $ionicModal;
        $ionicModal.show();
      }, {
        scope: scope,
        animation: 'slide-in-up',
        backdropClickToClose: false
      });
    });
  }

  showAdvancedConfirmation_Deprecated(params) {
    let confirmPopup = this.$ionicPopup.show({
      template: params.text,
      title: 'Techpad',
      buttons: [
        {
          text: 'Cancel',
          onTap(e) {
            if (typeof params.cancelAction == 'function') {
              params.cancelAction();
            }
          }
        },
        {
          text: params.saveButtonText || 'Save & Exit',
          type: 'button-positive ripple',
          onTap(e) {
            params.saveAction();
          }
        },
        {
          text: params.exitButtonText || 'Discard Changes',
          type: 'button-positive ripple',
          onTap(e) {
            params.exitAction();
          }
        }
      ]
    });
  }

  showAdvancedConfirmation(title, message, buttons) {
    let defer = this._qService.defer();
    if (!buttons || !buttons.length) {
      buttons = [ {
        text: 'No',
        onTap(e) {
          defer.resolve(false);
        }
      }, {
        text: 'Yes',
        type: 'button-positive',
        onTap(e) {
          defer.resolve(true);
        }
      } ];
    }

    let confirmPopup = this.$ionicPopup.show({
      template: message,
      title: title,
      buttons: buttons
    });

    return defer.promise;
  }

  showWorklistFilters(currentFilters, showAppointmentTime, showStudyDateOnWorklistPage) {
    this.showAppointmentTime = showAppointmentTime;
    this.showStudyDateOnWorklistPage = showStudyDateOnWorklistPage;
    const self = this;
    let defer = this._qService.defer();

    let scope = this.$rootScope.$new();

    scope.$on('modal.removed', () => {
      defer.resolve();
    });

    this.$ionicModal.fromTemplateUrl('views/templates/worklistFilters.html', ($ionicModal) => {
      scope.model = new self.WorklistFilterViewModel($ionicModal, currentFilters, self);
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });

    return defer.promise;
  }

  showWorklistChangeStatus(model, item, event) {
    let scope = this.$rootScope.$new();
    scope.vm = model;
    scope.id = item.Id;
    scope.item = item;
    scope.constantStrings = commonConstants.constantStrings;
    scope.isLinked = item.Study && item.Study.IsLinked;
    if ((item.Status === scope.constantStrings.worklistStatuses.New.status || item.Status === scope.constantStrings.worklistStatuses.SurveyStarted.status) && item.SDate) {
      scope.isAllowedToSkipSurvey = true;
      scope.ssn = item.Ssn;
      scope.sDate = item.SDate;
    }

    const showSurveyFinishedStatus = !scope.isLinked && item.Status !== scope.constantStrings.worklistStatuses.SurveyFinished.status;
    const showExamWaitingStatus = item.Status !== scope.constantStrings.worklistStatuses.ExamWaiting.status;
    const showExamIncompleteStatus = item.Status !== scope.constantStrings.worklistStatuses.ExamIncomplete.status;
    scope.showSkipSurveyStatus = scope.isAllowedToSkipSurvey && item.Status !== scope.constantStrings.worklistStatuses.ExamWaiting.status;

    scope.SurveyStatusItems = [
      {value : scope.constantStrings.worklistStatuses.SurveyFinished.status, shouldShow: showSurveyFinishedStatus },
      {value : scope.constantStrings.worklistStatuses.ExamWaiting.status, shouldShow: showExamWaitingStatus },
      {value : scope.constantStrings.worklistStatuses.ExamIncomplete.status, shouldShow: showExamIncompleteStatus }
    ]

    this.$ionicPopover.fromTemplateUrl('views/templates/worklistChangeStatus.html', {scope: scope})
        .then((popover) => {
          scope.modal = popover;
          popover.show(event);
        });
  }

  showWorklistChangeTags(model, item, event){
    let scope = this.$rootScope.$new();
    scope.vm = model;
    scope.id = item.Id;
    scope.item = item;
    scope.isTagSelected = function(item, tag){
      const tagsList = item.Tags && item.Tags.split(';') || [];
      return tagsList.some(t => t === tag.Value);
    };

    this.$ionicPopover.fromTemplateUrl('views/templates/worklistChangeTags.html', {scope: scope})
        .then((popover) => {
          scope.modal = popover;
          popover.show(event);
        });
  }

  showDashboardItemChangeStatus(model, item, event) {
    let scope = this.$rootScope.$new();
    scope.vm = model;
    scope.id = item.Id;
    scope.item = item;

    this.$ionicPopover.fromTemplateUrl('views/templates/dashboardChangeStatus.html', { scope: scope })
      .then((popover) => {
        scope.modal = popover;
        popover.show(event);
      });
  }

  showEnabledPrinters(document, printers) {
    const self = this;
    let defer = this._qService.defer();

    let scope = this.$rootScope.$new();

    scope.$on('modal.removed', () => {
      defer.resolve();
    });

    this.$ionicModal.fromTemplateUrl('views/templates/selectPrintersDialog.html', ($ionicModal) => {
      scope.model = new self.PrinterDocumentViewModel($ionicModal, self, document, printers);
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });

    return defer.promise;
  }

  showWorklistChangeListMessageAndResource(model, item, event, showRemoveListMsg, availableResources, isResourcesOnly) {
    let scope = this.$rootScope.$new();
    scope.vm = model;
    scope.worklistItem = item;
    scope.worklistItem.alreadySaved = false;
    scope.worklistItem.newListMessage = (this.authService.isRadiologist() ? item.RadListMessage : item.ListMessage) || '';
    scope.worklistItem.selectedResource = item.Resource || '';
    scope.id = item.Id;
    scope.showRemoveListMsg = showRemoveListMsg;
    scope.availableResources = availableResources;
    scope.isResourcesOnly = isResourcesOnly;
    scope.initialModel = {
      resource: scope.worklistItem.Resource,
      listMessage: scope.worklistItem.newListMessage
    };
    if(!scope.initialModel.resource){
      scope.initialModel.resource = '';
    }

    scope.vm.cannedNotesConfig = new CannedNotesModel({
      comment: scope.worklistItem.newListMessage,
      noteItems: model.techpadConfig.settings.CannedNotes.filter(
        (note) => note.CommentId === commonConstants.WORKLIST_MESSAGE_ID
      ),
    });

    this.$ionicPopover.fromTemplateUrl('views/templates/worklistChangeListMessageAndResource.html', { scope: scope, backdropClickToClose: true })
        .then((popover) => {
          scope.modal = popover;
          scope.checkAndApplyListMessageAndResourceIfNeeded = function( ){
            if(scope.initialModel.resource !== scope.worklistItem.selectedResource ||
              scope.initialModel.listMessage !== scope.worklistItem.newListMessage){
              scope.vm.applyListMessageAndResource(scope.worklistItem, scope.modal);
            }else{
              scope.modal.remove();
            }
          };
          popover.show(event);
          if(!scope.isResourcesOnly){
            scope.hiddenListener = scope.$on('popover.hidden', function() {
              scope.hiddenListener = null;
              if(!scope.worklistItem.alreadySaved && (
                scope.initialModel.resource !== scope.worklistItem.selectedResource ||
                scope.initialModel.listMessage !== scope.worklistItem.newListMessage
              )){
                scope.vm.applyListMessageAndResource(scope.worklistItem, scope.modal);
              }
              scope.initialModel = {};
            });
          }
        });
  }

  showWorklistChangeResource(model, item, event, showRemoveResource) {
    let scope = this.$rootScope.$new();
    scope.vm = model;
    scope.worklistItem = item;
    scope.id = item.Id;
    scope.showRemoveResource = showRemoveResource;
    this.$ionicPopover.fromTemplateUrl('views/templates/worklistChangeResource.html', {scope: scope})
        .then((popover) => {
          scope.modal = popover;
          popover.show(event);
        });
  }

  showWorklistChangeAdditionalInfo(model, item, event, showRemoveAdditionalInfo) {
    let scope = this.$rootScope.$new();
    scope.vm = model;
    scope.worklistItem = item;
    scope.id = item.Id;
    scope.showRemoveAdditionalInfo = showRemoveAdditionalInfo;
    this.$ionicPopover.fromTemplateUrl('views/templates/dashboardChangeAdditionalInfo.html', { scope: scope })
      .then((popover) => {
        scope.modal = popover;
        popover.show(event);
      });
  }

  closeAllModals() {
    var modals = document.getElementsByClassName(commonConstants.MODAL_CLASS);

    for (let modal of modals) {
      modal.remove();
    }

    $(commonConstants.MODAL_BACKGROUND_CLASS).remove();

    if ($(commonConstants.BODY_TAG).hasClass(commonConstants.POPOVER_CLASS)) {
      $(commonConstants.BODY_TAG).removeClass(commonConstants.POPOVER_CLASS);
    }
    
    if ($(commonConstants.BODY_TAG).hasClass(commonConstants.MODAL_OPEN_CLASS)) {
      $(commonConstants.BODY_TAG).removeClass(commonConstants.MODAL_OPEN_CLASS);
    }

    var popups = document.getElementsByClassName(commonConstants.POPUP_CONTAINER_CLASS);
    for (let popup of popups){
      popup.remove();
    }

    var popupsBackdrops = document.getElementsByClassName(commonConstants.POPUP_BACKGROUND_CLASS);
    for (let popupBackdrop of popupsBackdrops){
      popupBackdrop.classList.remove(commonConstants.POPUP_CONTAINER_ACTIVE_CLASS);
      popupBackdrop.classList.remove(commonConstants.POPUP_CONTAINER_VISIBLE_CLASS);
    }
    
    if ($(commonConstants.BODY_TAG).hasClass(commonConstants.POPUP_OPENED_BODY_CLASS)) {
      $(commonConstants.BODY_TAG).removeClass(commonConstants.POPUP_OPENED_BODY_CLASS);
    }
    
    if (this.$ionicModal.hide) {
      this.$ionicModal.hide();
    }

    if (this.$ionicPopover.hide) {
      this.$ionicPopover.hide();
    }
  }

  showDialogWindow(templateUrl, model, closeByButtonsClickOnly, options) {
    if (!model.init) {
      throw new Error('Viewmodel for dialog window must implement init() method');
    }

    const modalService = this;
    const ionicDatePicker = this.ionicDatePicker;
    let defer = this._qService.defer();
    let scope = this.$rootScope.$new();
    scope.model = model;

    this.$ionicModal.fromTemplateUrl(templateUrl, ($ionicModal) => {
      scope.modal = $ionicModal;
      if (closeByButtonsClickOnly) {
        $ionicModal.backdropClickToClose = false;
        modalService.$rootScope.$on('$locationChangeStart', () => {
          if (modalService.$ionicModal.hide) {
            modalService.$ionicModal.hide();
          }
        });
      }
      model.init($ionicModal, scope, modalService, ionicDatePicker);
      options && options.beforeWindowShow && options.beforeWindowShow();

      $ionicModal.show();

      setTimeout(() => {options && options.afterWindowShown && options.afterWindowShown();});
    }, {
      scope: scope,
      animation: 'slide-in-up'
    }).then((success) => {
    }, (error) => {
      let message = error.statusText;
      if (error.status === -1) {
        message = 'Network unavailable. Please check your network settings.'
      }
      this.$ionicPopup.alert({
        title: 'Techpad',
        template: message,
        okText: 'OK',
      });
    });
    // Execute action on hide modal
    scope.$on('modal.hidden', () => {
      if ($('body').hasClass('popover-open')) {
        $('body').removeClass('popover-open');
      }

      $('div.modal-backdrop.hide').remove();
      defer.resolve(model);
    });

    return defer.promise;
  }
  
  getPerformExamButtonLabel(model, item) {
    let buttonLabel = "";
    
    if (item.ArrivalStatus == commonConstants.PATIENT_ARRIVED_IMHERE_WORKLIST_STATUS) {
      buttonLabel = worklistConstants.READY_FOR_THE_PATIENT_EXAM_BUTTON_LABEL;
    } else if (model.isMyPatients) {
      buttonLabel = worklistConstants.MY_PATIENTS_BUTTOM_LABEL;
    } else {
      buttonLabel = worklistConstants.DEFAULT_PERFORM_EXAM_BUTTON_LABEL;
    }

    return buttonLabel;
  }

  showExamWindow(model, item) {
    let scope = this.$rootScope.$new();

    scope.model = model;
    scope.item = item;
    scope.performExamButtonLabel = this.getPerformExamButtonLabel(model, item);

    scope.closeModal = () => {
      scope.modal.hide();
    };

    this.$ionicModal.fromTemplateUrl('views/templates/examWindow.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });
    // Execute action on hide modal
    scope.$on('modal.hidden', function () {
      if ($('body').hasClass('popover-open')) {
        $('body').removeClass('popover-open');
      }

      $('div.modal-backdrop.hide').remove();
    });
  }

  showDashboardWindow(model, item) {
    let scope = this.$rootScope.$new();
    scope.model = model;
    scope.item = item;
    scope.item.newListMessage = this.authService.isRadiologist() ? item.RadListMessage : item.ListMessage;
    scope.item.oldListMessage = _.cloneDeep(scope.item.newListMessage);
    this.$ionicModal.fromTemplateUrl('views/templates/dashboardWindow.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
        scope: scope,
        animation: 'slide-in-up'
      });
    // Execute action on hide modal
    scope.$on('modal.hidden', function () {
      if ($('body').hasClass('popover-open')) {
        $('body').removeClass('popover-open');
      }

      $('div.modal-backdrop.hide').remove();
    });
  }

  showRequestedUltrasoundWindow(model, item) {
    let scope = this.$rootScope.$new();
    scope.model = model;
    scope.item = item;
    this.$ionicModal.fromTemplateUrl('views/templates/ultrasoundRequestWindow.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });
  }

  showStartSurveyWindow(model, item) {
    let scope = this.$rootScope.$new();
    scope.model = model;
    scope.item = item;
    this.$ionicModal.fromTemplateUrl('views/templates/startSurveyWindow.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });
  }

  showImagePreview(imageName) {
    let scope = this.$rootScope.$new();
    scope.imageName = imageName;
    this.$ionicModal.fromTemplateUrl('views/templates/imagePreview.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });
  }

  showHospitalCodeInputWindow() {
    let scope = this.$rootScope.$new();
    scope.data = {}

    let popup = this.$ionicPopup.show({
      template: '<input type="text" ng-model="data.code">',
      title: 'Enter your hospital code',
      subTitle: 'Code can contain only digits and letters',
      scope: scope,
      buttons: [
        {text: 'Cancel'},
        {
          text: '<b>Submit</b>',
          type: 'button-positive',
          onTap(e) {
            if (!scope.data.code) {
              e.preventDefault();
            } else {
              return scope.data.code;
            }
          }
        }
      ]
    });

    return popup;
  }

  showCommentsInputWindow(comment) {
    let scope = this.$rootScope.$new();
    scope.data = {comment: comment, prev: comment};

    let popup = this.$ionicPopup.show({
      template: '<textarea class="comment-area" ng-model="data.comment">',
      title: 'Enter the comment',

      scope: scope,
      buttons: [
        {
          text: 'Cancel',
          onTap() {
            return scope.data.prev;
          }
        },
        {
          text: '<b>Save</b>',
          type: 'button-positive',
          onTap(e) {
            return scope.data.comment || null;
          }
        }
      ]
    });

    return popup;
  }

  showTextFieldWindow(value) {
    let scope = this.$rootScope.$new();
    scope.data = {
      value: value,
      prev: value
    };

    let popup = this.$ionicPopup.show({
      template: '<textarea class="comment-area" ng-model="data.value">',
      title: 'Enter text',

      scope: scope,
      buttons: [
        {
          text: 'Cancel',
          onTap() {
            return scope.data.prev;
          }
        },
        {
          text: '<b>Save</b>',
          type: 'button-positive',
          onTap(e) {
            return scope.data.value || null;
          }
        }
      ]
    });

    return popup;
  }

  showDocumentWindow(model) {
    let scope = this.$rootScope.$new();
    scope.model = model;
    this.$ionicModal.fromTemplateUrl('views/templates/documentWindow.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });
  }

  showLinkedStudiesWindow(model) {
    let scope = this.$rootScope.$new();
    scope.model = model;
    let defer = this._qService.defer();

    scope.$on('modal.removed', function () {
      defer.resolve();
    });

    this.$ionicModal.fromTemplateUrl('views/templates/linkedStudiesWindow.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up'
    });

    return defer.promise;
  }

  showPatientDetails(model, updateData, callback) {
    let scope = this.$rootScope.$new();
    scope.vm = model;
    scope.vm.updateData = updateData;
    scope.vm.callback = callback;
    scope.vm.skipRedirecting = true;

    this.$ionicModal.fromTemplateUrl('views/templates/patientDetailsDialog.html', function ($ionicModal) {
      scope.modal = $ionicModal;
      $ionicModal.show();
    }, {
      scope: scope,
      animation: 'slide-in-up',
      backdropClickToClose: false,
      hardwareBackButtonClose: false
    });
  }

  async showChangePasswordWindow(model) {
    let scope = this.$rootScope.$new();
    scope.model = model;
    await model.init();

    let popup = this.$ionicPopup.show({
      template: `<span>New Password:</span>
                  <input type="password" ng-model="model.newPassword">
                  <br/>
                  <span>Confirm New Password:</span>
                  <input type="password" ng-model="model.repeatedNewPassword">
                  <span ng-if="model.error" class="change-password-error">{{model.error}}</span>`,
      title: 'Change Password',
      subTitle: 'Current security policy requires that you change your password. Please enter your new password.',
      scope: scope,
      buttons: [
        {
          text: '<b>Change Password</b>',
          type: 'button-positive',
          async onTap(e) {
            e.preventDefault();
            let result = await model.changePassword();
            if (!result.isError) {
              popup.close();
            }
          }
        }
      ]
    });

    return popup;
  }

  async showEnterYearPromptAsync(model){
    return new Promise(async (resolve) =>{
      let scope = this.$rootScope.$new();
      scope.model = model;
      scope.errorMessage = '';
      
      let popup = this.$ionicPopup.show({
        template: `<span><b>Enter a Year in a four-digit format (ex: 2020):</b></span>
                    <input type="number" ng-model="model.year"
                    min="${model.from}"
                    max="${model.to}">
                    <div class="error-color m-t-5" ng-show="errorMessage">{{errorMessage}}</div>`,
        title: 'Enter year',
        scope: scope,
        buttons: [
          {
            text: '<b>Done</b>',
            type: 'button-positive',
            onTap(e) {
              e.preventDefault();
              let result = model.getYear();
              if (!result){
                if (model.year === null) {
                  scope.errorMessage = 'Please specify a year';
                } else {
                  scope.errorMessage = 'Invalid year entered';
                }
                return;
              }
              scope.errorMessage = '';
              popup.close();
              resolve(result);
            }
          }
        ]
      });

    });
  }

  showPopupFromUrl(templateUrl, model, title, showCancelConfirmation = true) {
    return new Promise(async (resolve) => {
      let scope = this.$rootScope.$new();
      scope.model = model;
      scope.modal = this;
      let popup = this.$ionicPopup.show({
        templateUrl: templateUrl,
        title: title,
        scope: scope,
        cssClass: "comments-popup",
        buttons: [
          {
            text: 'Cancel',
            onTap(e) {
              if (scope.model.canCancel && !scope.model.canCancel()) {
                if (showCancelConfirmation) {
                  e.preventDefault();
                  scope.modal
                    .showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?')
                    .then(confirmed => {
                      resolve(null);
                      confirmed && popup.close();
                    });
                }
                else {
                  resolve(null);
                }
              }
              else {
                resolve(null);
              }
            }
          },
          {
            text: '<b>Save</b>',
            type: 'button-positive',
            onTap(e) {
              if (!scope.model.canSave || scope.model.canSave && scope.model.canSave()) {
                resolve(scope.model.comment);
              }
              else {
                e.preventDefault();
              }
            }
          }
        ]
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/modal.js